import { render, staticRenderFns } from "./DaysHighlight.vue?vue&type=template&id=5caa0270&"
import script from "./DaysHighlight.vue?vue&type=script&lang=js&"
export * from "./DaysHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports